import React from "react";
import CTAButton from "../Buttons/CTAButton/CTAButton";

const MediaPressSection = () => {
  // Convert YouTube URL to embed format
  const videoId = "B10LaVPQJVU";
  const embedUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-[20px] sm:gap-[30px] lg:gap-[40px] bg-Color-White text-Color-Black font-[Montserrat] px-4 sm:px-8 lg:px-numbers-100 py-6 sm:py-8 lg:py-numbers-48 mt-8 sm:mt-12 lg:mt-numbers-64">
      {/* Video Container - Left Side */}
      <div className="relative w-full aspect-video rounded-lg overflow-hidden shadow-lg">
        <iframe
          src={embedUrl}
          title="Media Press Showcase"
          className="absolute top-0 left-0 w-full h-full"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      {/* Typography Content - Right Side */}
      <div className="border-l-2 border-l-Color-Brand py-4 sm:py-8 lg:py-numbers-16 pl-4 sm:pl-6 lg:pl-numbers-32">
        <h1 className="text-xl sm:text-2xl lg:text-h2-desktop mb-2 sm:mb-3 lg:mb-4 leading-loose lg:leading-[1]">
          Official Media Launch of
        </h1>
        <span className="text-Color-Brand text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-semibold font-['Montserrat'] underline">
          REXTRO 2025
        </span>
        <p className="leading-tight mt-4 sm:mt-6 lg:mt-[40px] font-weight-medium text-sm sm:text-base lg:text-body-desktop">
          Witness the remarkable journey of the Faculty of Engineering at
          University of Ruhuna through our media coverage. Experience the
          highlights of our 25th anniversary celebrations, innovation showcases,
          and the impact we've made in engineering education and research over
          the years.
        </p>
        <div className="mt-4 sm:mt-6 lg:mt-[40px]">
          <CTAButton
            text="VIEW MORE COVERAGE"
            url="https://www.youtube.com/@refmedia"
            isRainbow={true}
          />
        </div>
      </div>
    </div>
  );
};

export default MediaPressSection;
